module.exports = "/365FarmNet/dist/companySettings.d5f9c9cc2bf768a556c70421bab9f051.html";